<template>
  <div class="item-list-page">
    <div class="-content d-flex align-items-start flex-column">
      <div class="page-global-header px-0 mt-3">
        <div class="row justify-content-center">
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3"
          >
            <div class="global-searchbar laurenGreen">
              <form class="base-form" @submit.prevent>
                <div class="input-group">
                  <div class="input-group-text">
                    <img src="@/assets/images/system/tools.svg" />
                  </div>
                  <input
                    type="search"
                    name="globalSearch"
                    class="form-control"
                    placeholder="Search (Company name, Client name, Email etc)"
                    v-model="itemSearchQuery"
                  />
                  <button type="button" name="btnSearch" class="btn btn-lauren-green">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 d-flex align-items-center justify-content-end"
            style="padding-right: 200px;"
          >
            <ul class="search-option-menu me-3">
              <li class="nav-item me-2">
                <a
                  href="#"
                  class="nav-link circleNav"
                  @click="dialogVisibleCategoryPopup = true"
                >
                  <img src="@/assets/images/system/network-group.png" />
                </a>
              </li>

              <li class="nav-item sorting">
                <input
                  type="checkbox"
                  class="sorting-check"
                  id="btn-sorting"
                  autocomplete="off"
                  v-model="sortOrderAsc"
                />
                <label class="btn btn-sorting" for="btn-sorting"
                  ><span class="sr-only">Sort</span>
                </label>
              </li>
              <li class="nav-item">
                <router-link class="nav-link circleNav" :to="{ name: 'add-item' }">
                  <i class="fa fa-plus"></i>
                </router-link>
              </li>
              <li class="nav-item dropdown">
                <a
                  href="#"
                  class="nav-link dropdown-toggle no-caret"
                  id="optionMore"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  ><i class="fa fa-ellipsis-v"></i>
                </a>
                <ul
                  class="dropdown-menu dropdown-menu-end _v1"
                  aria-labelledby="optionMore"
                >
                  <li>
                    <a class="dropdown-item" href="#"
                      >Email CSV/PDF/Zip<i class="fa fa-envelope append"></i>
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#"
                      >Analytics <i class="fas fa-chart-line append"></i>
                    </a>
                  </li>

                  <li>
                    <a class="dropdown-item" href="#"
                      >Print <i class="fa fa-print append"></i
                    ></a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#"
                      >Download PDF/CSV <i class="fa fa-download append"></i>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3 mt-3"
          >
            <div class="global-filter-form">
              <form class="base-form form-xl d-flex flex-row">
                <select class="form-select _3d-input" v-model="searchCategory">
                  <option value="">Categories</option>
                  <option v-for="cat in categories" :key="cat.id" :value="cat.type">
                    {{ cat.type }}
                  </option>
                </select>
                <button type="button" class="btn btn-white _3d-input _sq" :class="{ 'active-filter': filterType === 'parts' }" @click="setFilter('parts')">
                  <i class="fa fa-cog"></i>
                </button>
                <button type="button" class="btn btn-white _3d-input _sq" :class="{ 'active-filter': filterType === 'service' }" @click="setFilter('service')">
                  <i class="fas fa-running"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="page-body item-list-scroll-area custom-scroll">
        <div class="row justify-content-center client-list-row">
          <!--repeatable block-->
          <div
            class="col-12 client-card-col mb-3"
            v-for="(item, index) in filteredItems"
            :key="index"
          >
            <div class="card card-horizontal-list laurenGreen">
              <div class="card-body">

                <div class="card-content">
                  <span class="card-count">{{ index + 1 }}.</span>
                  <ul class="label-list">
                    <li class="list-title">
                      <label>C:</label
                      ><span class="list-text">{{ item.category_type }}</span>
                    </li>
                    <li class="sub-title">
                      <label>I:</label><span class="list-text">{{ item.name }}</span>
                    </li>
                    <li>
                      <label>I.No:</label
                      ><span class="list-text">{{ item.item_no }}</span>
                    </li>
                    <li class="mt-2">
                      <label>D:</label
                      ><span class="list-text">{{ item.description }}</span>
                    </li>
                  </ul>
                </div>
                <div class="content-option">
                  <ul class="cmn-vrList">
                    <li v-if="item.type === 'parts'">
                      <a href="#"><i class="fa fa-cog"></i> </a>
                    </li>
                    <li v-if="item.type === 'service'">
                      <a href="#"><i class="fas fa-running"></i> </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-footer has-action">
                <div class="ellipsis-dropdown dropdown">
                  <button
                    class="btn dropdown-toggle no-caret"
                    type="button"
                    id="card-dropAction-1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="fas fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="card-dropAction-1">
                    <li>
                      <router-link class="dropdown-item edit" :to="{ name: 'edit-item', params: { id: item.id } }"
                        ><i class="fa fa-edit"></i>
                      </router-link>
                    </li>
                    <li>
                      <a
                        class="dropdown-item delete"
                        @click="deleteItem(item.id, item.item_no)"
                        href="#"
                        ><i class="fa fa-times"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="footer-list-wraper">
                  <ul class="footer-list">
                    <li>Quantity</li>
                    <li class="count">{{ formatToTwoDecimal(item.quantity) }}</li>
                  </ul>

                  <ul class="footer-list highlight">
                    <li>Rate</li>
                    <li class="count">
                      {{$auth.user?.currency}}{{ formatToTwoDecimal(item.unit_price) }}
                    </li>
                  </ul>

                  <ul class="footer-list _big">
                    <li>Price</li>
                    <li class="count">
                      {{$auth.user?.currency}}{{ formatToTwoDecimal(item.unit_price * item.quantity) }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!--ended repeatable block-->
        </div>
      </div>
    </div>

    <el-dialog v-model="dialogVisibleCategoryPopup" width="40%" class="category-dialog">
      <template #header>
        <button class="btn btn-lauren-green btn-sm"><img src="@/assets/images/system/network-group-white.png" style="width: .70rem;" /> Add Category </button>
      </template>
      <addCategory></addCategory>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisibleCategoryPopup = false">Close</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import AddCategory from "./Category.vue";

export default {
  name: "ItemList",
  components: { AddCategory },
  data() {
    return {
      loadingInstance: null,
      item_server_data: [],
      dialogVisibleCategoryPopup: false,
      type: "",
      categories: [],
      showHideCheckboxToAddToQuotation: false,
      showHideCheckbox: false,
      addItemToRecentList: [],
      itemSearchQuery: "",
      searchCategory: "",
      filterType: "all",
      sortOrderAsc: true,
    };
  },
  computed: {
    filteredItems() {
      const searchTerm = this.itemSearchQuery.toLowerCase();
      // Values are coerced before matching: a missing name or a numeric item_no
      // used to throw here, which emptied the whole list instead of filtering it.
      const has = (value) => String(value ?? "").toLowerCase().includes(searchTerm);

      let filtered = this.item_server_data.filter((item) => {
        const matchesSearch =
          !searchTerm ||
          has(item.name) ||
          has(item.item_no) ||
          has(item.description) ||
          has(item.category_type) ||
          has(item.client_name) ||
          has(item.business_name);

        const matchesCategory = this.searchCategory
          ? item.category_type === this.searchCategory
          : true;

        const matchesType =
          this.filterType !== "all" ? item.type === this.filterType : true;

        return matchesSearch && matchesCategory && matchesType;
      });

      filtered.sort((a, b) => {
        const nameA = (a.name || "").toLowerCase();
        const nameB = (b.name || "").toLowerCase();
        if (nameA < nameB) return this.sortOrderAsc ? -1 : 1;
        if (nameA > nameB) return this.sortOrderAsc ? 1 : -1;
        return 0;
      });

      return filtered;
    },
  },
  created() {
    this.runMountedFunctions();
  },
  methods: {
    runMountedFunctions() {
      this.$store.dispatch("item/fetchCategory").then((res) => {
        this.categories = res;
        this.getData();
      });
    },
    formatToTwoDecimal(number) {
      return Number(number).toFixed(2);
    },
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    getData() {
      this.showLoading();
      this.$store
        .dispatch("item/getList", this.form || {})
        .then((res) => {
          // Unwrap only a raw axios response. The API envelope itself has a top-level
          // `data` key, so a plain truthiness check on res.data grabbed the payload
          // array instead of the envelope and every list rendered empty.
          const apiRes = res?.data?.status !== undefined ? res.data : res;

          if (String(apiRes.status) === "1") {
            this.item_server_data = apiRes.response;
            console.log("Fetched items:", this.item_server_data);
          } else {
            const errorMsg =
              apiRes.message?.length > 0
                ? Array.isArray(apiRes.message)
                  ? apiRes.message.join("\n")
                  : apiRes.message
                : "Something went wrong. Please try again.";
            this.$toast.error(errorMsg);
            throw new Error(errorMsg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.item_server_data = [];
          if (!err.message) {
            this.$toast.error("Something went wrong. Please try again.");
          }
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    deleteItem(item_id, item_no = "") {
      this.showLoading();
      this.removeItemFromRecentList(item_no);
      this.$store
        .dispatch("item/deleteItem", { item_id: item_id })
        .then((res) => {
          if (res.status == 1) {
            this.$toast.success("Delete data Successful.");
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.getData();
        });
    },
    showAddItemCheckbox() {
      if (this.showHideCheckboxToAddToQuotation) {
        this.showHideCheckbox = true;
      } else {
        this.showHideCheckbox = false;
      }
    },
    addToRecentItems(item_no) {
      this.$store.dispatch("item/getList", item_no).then(() => {
        this.$store.commit("item/addToRecentItemsInvoice", item_no);
      });
    },
    removeItemFromRecentList(itemNoToRemove) {
      this.$store.commit("item/removeItemFromRecentList", itemNoToRemove);
    },
    setFilter(type) {
      if (this.filterType === type) {
        this.filterType = "all";
      } else {
        this.filterType = type;
      }
    },
  },
};
</script>

<style scoped>
.hover-slidess {
  position: relative;
  top: 1rem;
  left: 1rem;
}
.custom-scroll {
  max-height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 5px;
}
.custom-scroll::-webkit-scrollbar {
  width: 6px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 4px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
</style>
